import { twMerge } from "tailwind-merge";

interface IAdditionalServiceBadgeProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  color?: "paleSky" | "green" | "purple";
}

export const AdditionalServiceBadge: React.FC<
  React.PropsWithChildren<IAdditionalServiceBadgeProps>
> = (props) => {
  const { children, className, color = "paleSky", ...rest } = props;
  return (
    <span
      className={twMerge(
        "inline-flex items-center self-start whitespace-nowrap rounded-full px-3 py-1 text-sm font-medium shadow-xl",
        color === "green" && "bg-green-light text-green-dark",
        color === "purple" && "bg-purple-light text-purple-dark",
        color === "paleSky" && "bg-paleSky-light text-paleSky-dark",
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
};
